import { SelectedFilters } from "models/inbox/inbox";

export function getFiltersQueryParams(
  activeFilters: SelectedFilters & { categories: string[] }
) {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(activeFilters)) {
    if (typeof value === "boolean" && value) {
      params.append(key, "true");
    }
  }
  if (
    Array.isArray(activeFilters.categories) &&
    activeFilters.categories.length > 0
  ) {
    activeFilters.categories.forEach((cat) => params.append("category", cat));
  }

  const queryString = params.toString();
  return queryString;
}
